import React, { useState, useEffect } from "react";

const withExtend = (WrappedComponent) => {
  const ExtendDecorator = (props) => {
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
      let collapseStatus = JSON.parse(localStorage.getItem(props.id));
      if (props.id == undefined) {
        setCollapsed(false);
      } else {
        if (!!collapseStatus ? collapseStatus["isCollapsed"] : false) {
          setCollapsed(true); 
        } else {
          localStorage.setItem(
            props.id,
            JSON.stringify({ isCollapsed: false })
          );
          setCollapsed(false);
        }
      }
    }, [props]);

    const onClick = () => {
      localStorage.setItem(
        props.id,
        JSON.stringify({ isCollapsed: !collapsed })
      );
      setCollapsed(!collapsed);
    };

    return (
      <WrappedComponent {...props} onClick={onClick} collapsed={!collapsed} />
    );
  };
  return ExtendDecorator;
};

export default withExtend;
